import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_4110356259 from "../../../../../packages/component/src/components/dialog/demo/demo1.js?loadDemo";
import legacyImportDemo_3353621312 from "../../../../../packages/component/src/components/dialog/demo/demo2.js?loadDemo";
import legacyImportDemo_3672418401 from "../../../../../packages/component/src/components/dialog/demo/demo3.js?loadDemo";
import legacyImportDemo_775067270 from "../../../../../packages/component/src/components/dialog/demo/demo4.js?loadDemo";
import legacyImportDemo_2009297063 from "../../../../../packages/component/src/components/dialog/demo/demo5.js?loadDemo";
import legacyImportDemo_1880920772 from "../../../../../packages/component/src/components/dialog/demo/demo6.js?loadDemo";
import legacyImportDemo_78975461 from "../../../../../packages/component/src/components/dialog/demo/demo7.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_4110356259,
  legacyImportDemo_3353621312,
  legacyImportDemo_3672418401,
  legacyImportDemo_775067270,
  legacyImportDemo_2009297063,
  legacyImportDemo_1880920772,
  legacyImportDemo_78975461,
  React
};